import { Autocomplete, Button, Dialog, Stack, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";

function BPVoucher({
  okCallback,
  okCallback2,
  cancelCallback,
  updateCallback,
  vtype,
  visible,
  level3Codes,
  level3CodesFiltered,
  singleEntryVoucher,
  isEdit,
  voucherRowData,
}) {
  console.log(voucherRowData);
  const transactionTypes = ["Debit", "Credit"];
  const [codes, setCodes] = useState(level3CodesFiltered);
  const cheques = ["1234", "1235", "1236", "1237"];
  let Data, addonly;

  const [form, setForm] = useState({
    amount: isEdit ? voucherRowData?.defaultAmount : null,
    description: isEdit ? voucherRowData?.defaultDescription : "",
    description2: "",
    billno: "",
    cheque: "",
    code: isEdit ? voucherRowData?.newcode : "",
    code2: "",
    type: isEdit ? voucherRowData?.defaultTransactionType : "",
  });

  const handleInputChange = (event) => {
    setForm({
      ...form,
      [event.target.name]: event.target.value,
    });
  };

  console.log(form);

  const handleInputChange1 = (name, value) => {
    setForm({
      ...form,
      [name]: value,
    });
  };

  const handleChangeType = () => {
    singleEntryVoucher &&
      setForm({
        ...form,
        type: "Debit",
      });
  };

  const code = form.code;
  const type = form.type;
  const code2 = form.code2;

  const resetAll = () => {
    setForm({
      ...form,
      amount: "",
      cheque: "",
      description: "",
      description2: "",
      billno: "",
      code: "",
      type: "",
      code2: "",
    });
  };
  const codeOption = codes.map((item) => {
    return item.fullcode + "\t" + item.Discription + "\t" + item.type;
  });

  useEffect(() => {
    console.log(level3CodesFiltered, level3Codes);
    console.log(type);
    console.log(codes);
    if (type == "Debit" && (vtype == "BRV" || vtype == "CRV")) {
      setCodes(level3CodesFiltered);
    } else if (type == "Credit" && (vtype == "CPV" || vtype == "BPV")) {
      setCodes(level3CodesFiltered);
    } else if (vtype == "JV") {
      setCodes(level3CodesFiltered);
    } else {
      setCodes(level3Codes);
    }
    console.log(codes);
  }, [type]);

  const handleUpdate = () => {
    let debitAmount = "";
    let creditAmount = "";

    if (type == "Debit") {
      debitAmount = form.amount;
    } else {
      creditAmount = form.amount;
    }

    const data = {
      transaction: type,
      debit: debitAmount,
      credit: creditAmount,
      amount: form.amount,
      code: code,
      Discription: form.description,
      cheque: form.cheque,
      billno: form.billno,
      transactionType: type,
      type: vtype,
    };
    updateCallback(data);
  };

  const handleAdd1 = (addOnly) => {
    const particular = code.split("\t")[1];
    const sCode = code.split("\t")[0];
    if (form.amount == "" || code == "" || form.description == "") {
      alert("Please enter all fields");
    } else if (parseInt(form.amount) <= 0) {
      alert("Amount should be greater than 0");
    } else {
      let debitAmount = "";
      let creditAmount = "";

      if (!singleEntryVoucher) {
        if (type == "Debit") {
          debitAmount = form.amount;
        } else {
          creditAmount = form.amount;
        }
      } else {
        debitAmount = form.amount;
      }
      const data1 = {
        transaction: singleEntryVoucher ? "Debit" : type,
        debit: debitAmount,
        credit: creditAmount,
        amount: form.amount,
        code: sCode,
        particular,
        Discription: form.description,
        cheque: form.cheque,
        billno: form.billno,
        transactionType: singleEntryVoucher ? "Debit" : type,
        type: vtype,
      };
      if (singleEntryVoucher) {
        Data = data1;
        addonly = addOnly;
      } else {
        okCallback(data1,addOnly);
      }
      {
        addOnly && resetAll();
      }
    }
  };

  const handleAdd2 = () => {
    console.log("first2");
    const particular = code2.split("\t")[1];
    const sCode = code2.split("\t")[0];
    if (form.amount === "" || code == "" || form.description == "") {
    } else if (code2 == "" || form.description2 == "") {
      alert("Please enter all fields");
    } else if (parseInt(form.amount) <= 0) {
      alert("Amount should be greater than 0");
    } else {
      okCallback(Data, addonly);
      let debitAmount = "";
      let creditAmount = "";

      creditAmount = form.amount;

      const data2 = {
        transaction: singleEntryVoucher ? "Credit" : type,
        debit: debitAmount,
        credit: creditAmount,
        amount: form.amount,
        code: sCode,
        particular,
        Discription: form.description2,
        cheque: form.cheque,
        billno: form.billno,
        transactionType: singleEntryVoucher ? "Credit" : type,
        type: vtype,
      };
      okCallback2(data2);
    }
  };

  const handleAdd = () => {
    const addOnly = true;
    handleAdd1(addOnly);
    singleEntryVoucher && handleAdd2();
  };

  const handleAddClose = () => {
    const addOnly = false;
    handleAdd1(addOnly);
    singleEntryVoucher && handleAdd2();
  };

  const handleCancel = () => {
    console.log(level3Codes);
    cancelCallback();
  };

  const style = {
    display: "flex",
    flexDirection: "column",
    bgcolor: "#379683",
    justifyContent: "flex-start",
    alignItems: "center",
  };

  return (
    <Dialog style={style} open={visible} onClose={cancelCallback}>
      <Stack
        style={{
          minWidth: "40vw",
          height: "60vh",
          padding: "2rem",
        }}
        alignItems="center"
      >
        {!singleEntryVoucher && (
          <Autocomplete
            onChange={(event, newValue) => {
              handleInputChange1("type", newValue);
            }}
            name="type"
            style={{ width: "90%" }}
            disablePortal
            id="combo-box-Tranaction-type"
            getOptionLabel={(option) => option}
            options={transactionTypes}
            value={type}
            disabled={isEdit}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Transaction Type"
                variant="standard"
              />
            )}
          />
        )}

        <TextField
          size="5"
          style={{ width: "90%" }}
          value={form.amount}
          onChange={handleInputChange}
          name="amount"
          variant="standard"
          required
          id="outlined-required"
          label="Amount"
          type="number"
        ></TextField>
        {vtype == "BPV" || vtype == "BRV" ? (
          <>
            {!singleEntryVoucher && (
              <Autocomplete
                onChange={(event, newValue) => {
                  handleInputChange1("cheque", newValue);
                }}
                name="cheque"
                style={{ width: "90%" }}
                disablePortal
                id="combo-box-cheque"
                getOptionLabel={(option) => option}
                options={cheques}
                value={form.cheque}
                renderInput={(params) => (
                  <TextField {...params} label="Cheque#" variant="standard" />
                )}
              />
            )}
          </>
        ) : (
          <></>
        )}

        {vtype == "JV" ? (
          <TextField
            value={form.billno}
            onChange={handleInputChange}
            name="billno"
            style={{ width: "90%" }}
            variant="standard"
            required
            id="outlined-required"
            label="Bill/Inv #"
          ></TextField>
        ) : (
          <></>
        )}

        {console.log("Optionsssss: ", codes)}
        <Autocomplete
          style={{ width: "90%" }}
          disablePortal
          id="combo-box-code"
          options={codeOption}
          value={form.code}
          onChange={(event, newValue) => {
            handleInputChange1("code", newValue);
          }}
          name="code"
          disabled={isEdit}
          onFocus={() => handleChangeType()}
          renderInput={(params) => (
            <TextField
              {...params}
              label={singleEntryVoucher ? "Debit Code" : "Code"}
              variant="standard"
            />
          )}
        />
        <TextField
          value={form.description}
          onChange={handleInputChange}
          name="description"
          style={{ width: "90%" }}
          variant="standard"
          id="outlined-required"
          label="Description"
        ></TextField>

        {singleEntryVoucher && (
          <>
            <Autocomplete
              style={{ width: "90%" }}
              disablePortal
              id="combo-box-code"
              onChange={(event, newValue) => {
                handleInputChange1("code2", newValue);
              }}
              name="code2"
              options={codeOption}
              value={form.code2}
              onFocus={() =>
                setForm({
                  ...form,
                  type: "Credit",
                })
              }
              renderInput={(params) => (
                <TextField {...params} label="Credit Code" variant="standard" />
              )}
            />

            <TextField
              value={form.description2}
              onChange={handleInputChange}
              name="description2"
              style={{ width: "90%" }}
              id="outlined-required"
              label="Description"
              variant="standard"
            ></TextField>
          </>
        )}

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-evenly",
            alignItems: "center",
            marginTop: "5%",
            width: "90%",
          }}
        >
          <Button
            style={{
              backgroundColor: "#379683",
              color: "white",
              marginTop: 5,
              marginBottom: 5,
            }}
            onClick={handleCancel}
          >
            CANCEL
          </Button>
          {!singleEntryVoucher && !isEdit && (
            <Button
              style={{
                backgroundColor: "#379683",
                color: "white",
                marginTop: 5,
                marginBottom: 5,
              }}
              onClick={handleAdd}
            >
              Add
            </Button>
          )}
          <Button
            style={{
              backgroundColor: "#379683",
              color: "white",
              marginTop: 5,
              marginBottom: 5,
            }}
            onClick={isEdit ? handleUpdate : handleAddClose}
          >
            {isEdit ? "Update" : "Add & Close"}
          </Button>
        </div>
      </Stack>
    </Dialog>
  );
}

export default BPVoucher;
